import { Directive, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appMuNotImagenCustom]',
})
export class MuNotImagenCustomDirective {
  constructor(private renderer2: Renderer2) {
    /** */
  }

  @HostListener('error') loadDefaultImage() {
    const parentNode = document.getElementById('mu-public-layout-header');
    const nodeClildTwo = document.getElementById('mu-public-layout-block-2');
    const nodeClildThree = document.getElementById('mu-public-layout-block-3');
    this.renderer2.removeChild(parentNode, nodeClildTwo);
    this.renderer2.removeClass(nodeClildThree, 'mu-visibility');
  }
}
